import {FileType} from './file-type';

export class FileInfo {

  constructor(public id: number,
              public fileName: string,
              public type: FileType,
              public order: number,
              public year: number) {}

}
